var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { useChat } from '@shapeable/ui';
import { classNames } from '@shapeable/utils';
var cls = classNames('chat-input-button');
export var ChatFormButtonDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["  \n    ", ";\n    font-size: ", ";\n    border-radius: ", ";\n    border: none;\n    height: 32px;\n    padding: ", " ", ";\n    color: ", ";\n    font-family ", ";\n    font-weight: 500;\n\n    ", "\n\n    ", "\n\n    ", "\n  "], ["  \n    ", ";\n    font-size: ", ";\n    border-radius: ", ";\n    border: none;\n    height: 32px;\n    padding: ", " ", ";\n    color: ", ";\n    font-family ", ";\n    font-weight: 500;\n\n    ", "\n\n    ", "\n\n    ", "\n  "])), theme.REMOVE_BUTTON_STYLE(), theme.FONT_SIZE(14), theme.UNIT(2), theme.UNIT(1.25), theme.UNIT(3), theme.COLOR('light'), theme.FONT('sans'), function (_a) {
    var _color = _a._color;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      background: ", ";\n      &:focus {\n        outline: 1px solid ", ";\n      }\n    "], ["\n      background: ", ";\n      &:focus {\n        outline: 1px solid ", ";\n      }\n    "])), theme.COLOR(_color), theme.HOVER_COLOR(_color, 0.2));
  }, function (_a) {
    var disabled = _a.disabled;
    return disabled && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      opacity: 0.5;\n    "], ["\n      opacity: 0.5;\n    "])));
  }, function (_a) {
    var disabled = _a.disabled,
      _color = _a._color;
    return !disabled && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      cursor: pointer;\n      &:hover {\n        background: ", ";\n      }\n    "], ["\n      cursor: pointer;\n      &:hover {\n        background: ", ";\n      }\n    "])), theme.HOVER_COLOR(_color, 0.1));
  })
});
// -------- Components -------->
var My = {
  Container: styled.button(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var ChatFormButton = function (props) {
  var className = props.className,
    onClick = props.onClick,
    children = props.children,
    title = props.title,
    disabled = props.disabled;
  var chat = useChat();
  var color = props.color || chat.color || 'primary';
  return React.createElement(My.Container, {
    title: title,
    type: "button",
    _color: color,
    disabled: disabled,
    onClick: onClick,
    className: cls.name(className)
  }, children);
};
ChatFormButton.cls = cls;
ChatFormButton.defaultProps = ChatFormButtonDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;